import { InputType } from "../types";

export const CompareInput: InputType = [{ value: 'a', type: 'string' }, { value: 'ä', type: 'string' }];

export const StringLocaleCompareInput: InputType = [{ value: 'réservé', type: 'string' }, { value: 'RESERVE', type: 'string' }];

